/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */
import HEADERS from './_http-headers';
import fetchJSON from './fetchJSON';
import fetch from './fetch';
import ajax from './ajax';

fetchJSON.HEADERS = HEADERS;
fetch.HEADERS = HEADERS;
ajax.HEADERS = HEADERS;

export default {
  fetch,
  fetchJSON,
  ajax,
};
